/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBookmarkCuteFi: {
  name: 'bookmark-cute-fi';
  data: string;
} = {
  name: 'bookmark-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.12 2.564c-1.461.126-2.328.468-3.007 1.188-.594.63-.884 1.38-1.037 2.688-.036.308-.054 1.971-.066 6.22-.017 5.903-.002 6.729.132 7.296.239 1.017 1.04 1.617 1.982 1.483.631-.089 1.336-.499 2.728-1.587 1.177-.92 1.841-1.332 2.148-1.332s.971.412 2.148 1.332c1.714 1.339 2.444 1.697 3.235 1.585a1.61 1.61 0 0 0 .937-.474c.421-.426.572-.867.642-1.877.064-.904.03-12.068-.038-12.646-.153-1.308-.443-2.058-1.037-2.688-.692-.734-1.533-1.06-3.067-1.19-.562-.048-5.141-.046-5.7.002"/></svg>`
};
